// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import styled from 'styled-components';
import Button from '../../../components/Button';
import CrossIcon from '../../../assets/images/cross-icon-white.svg';
import HightlightIcon from '../../../assets/images/button-active.svg';
import { FormattedMessage } from 'react-intl';

const S = {
  PopMask: styled.div`
    background: #FFFFFF;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9999;
  `,
  SubmitContainer: styled.div`
    background: #FFFFFF;
    border-radius: 11px;
    margin-top: 11px;
    position: fixed;
    font-size: 26px;
    line-height: 38px;
    color: #353535;
    top: 10%;
    left: 50%;
    transform: translate(-50%,0%);
  `,
  CloseBar: styled.div`
    background: #EF8200;
    border-radius: 11px 11px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 17px 17px 19px;
  `,
  CloseIcon: styled.img.attrs({ src: CrossIcon})`
    max-width: 11px;
    cursor: pointer;
  `,
  SubmitContent: styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    padding: 39px 100px;
    overflow-y: auto;
    max-height: 400px;
  `,
  SubmitAction: styled.div`
    display: flex;
    justify-content: center;
    margin: 10px 0 30px;
  `,
  CancelButton: styled(Button)`
    background: #7A7A7A;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 7px 0px 0px 7px;
    padding: 4px 27px;
    margin-right: 14px;
  `,
  SubmitButton: styled(Button)`
    background: #EF8200;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 0px 7px 7px 0px;
    padding: 4px 27px;
  `,
  SubmitText: styled.p`
    margin-bottom: 20px;
  `,
  ScoreText: styled.p`
    font-size: 18px;
    display: flex;
    width:100%;
  `,
  HightlightIcon: styled.img.attrs({ src: HightlightIcon })`
    padding-right: 10px;
    display: block;
  `,
}

const ConfirmSubmit = (props: any): JSX.Element => {
  const setClickSubmit = props.setClickSubmit;
  const handleSubmit = props.handleSubmit;
  const totalScore = props.totalScore;
  const reviewScore = props.reviewScore;

  const handleClose = () => {
    setClickSubmit(false);
  }

  const handleConfirm = () => {
    handleSubmit();
    setClickSubmit(false);
  }

  return (
    <>
      <S.PopMask>
        <S.SubmitContainer>
          <S.CloseBar><S.CloseIcon onClick={handleClose}/></S.CloseBar>
          <S.SubmitContent>
            <S.SubmitText>
              <FormattedMessage id="K034" />
            </S.SubmitText>
            <S.ScoreText><S.HightlightIcon /><FormattedMessage id="K040" />{totalScore}</S.ScoreText>
            <S.ScoreText><S.HightlightIcon /><FormattedMessage id="K041" />{reviewScore}</S.ScoreText>
          </S.SubmitContent>
          <S.SubmitAction>
            <S.CancelButton onClick={handleClose}><FormattedMessage id="E065" /></S.CancelButton>
            <S.SubmitButton onClick={handleConfirm}><FormattedMessage id="K003" /></S.SubmitButton>
          </S.SubmitAction>
        </S.SubmitContainer>
      </S.PopMask>
    </>
  )
}

export default ConfirmSubmit;
